import { httpRequest } from "@services/http";
import { legacyDashboardUrl } from "@/modules/opLaunchPages/services/legacyDashboardUrl";
import type { ReportResult } from "../models";

export class CommandRunReport {
    async run(key: string, params: Record<string, string>): Promise<ReportResult> {
        const url = legacyDashboardUrl(`reports/${key}/`);
        Object.entries(params).forEach(([name, value]) => {
            if (value) url.searchParams.set(name, value);
        });
        return await httpRequest<ReportResult>(url.toString());
    }
}
